import React, { FC } from 'react';
import { Step } from 'react-joyride';

import { Walkthrough, WalkthroughStep } from 'components';

import StepOne from './StepOne';

const Desktop: FC = () => {
  const steps: Step[] = [
    {
      placement: 'center',
      target: 'body',
      content: (
        <WalkthroughStep
          stepWidth={540}
          headerOptions={{
            type: 'custom',
            asset: <StepOne format="desktop" />,
          }}
          contentOptions={{
            variant: 'subtitle2',
            text: 'walkthrough:step_1_text',
            icons: 'walkthrough:step_1_icons',
          }}
        />
      ),
      locale: {
        next: 'walkthrough:ok_got_it',
      },
    },
    {
      placement: 'bottom',
      target: '#menu-item-common-group_plural',
      content: (
        <WalkthroughStep
          headerOptions={{
            type: 'image',
            asset: '/images/walkthrough/step-2.svg',
          }}
          contentOptions={{
            text: 'walkthrough:step_2_text',
            icons: 'walkthrough:step_2_icons',
          }}
        />
      ),
      locale: {
        next: 'walkthrough:makes_sense',
      },
    },
    {
      placement: 'bottom',
      target: '#menu-item-common-person_plural',
      content: (
        <WalkthroughStep
          headerOptions={{
            type: 'image',
            asset: '/images/walkthrough/step-3.svg',
          }}
          contentOptions={{
            text: 'walkthrough:step_3_text',
            icons: 'walkthrough:step_3_icons',
          }}
        />
      ),
      locale: {
        next: 'walkthrough:got_it',
      },
    },
    {
      placement: 'bottom',
      target: '.createPostForm',
      content: (
        <WalkthroughStep
          headerOptions={{
            type: 'image',
            asset: '/images/walkthrough/step-4.svg',
          }}
          contentOptions={{
            text: 'walkthrough:step_4',
            icons: 'walkthrough:step_3_icons',
          }}
        />
      ),
      locale: {
        last: 'walkthrough:lets_do_it',
      },
    },
  ];

  return <Walkthrough steps={steps} storageKey="desktopWalkthrough" />;
};

export default Desktop;
